import { render, staticRenderFns } from "./BoxStyleOptions.vue?vue&type=template&id=74a56321"
import script from "./BoxStyleOptions.vue?vue&type=script&lang=js"
export * from "./BoxStyleOptions.vue?vue&type=script&lang=js"
import style0 from "./BoxStyleOptions.vue?vue&type=style&index=0&id=74a56321&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports